module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "toctitlea"
  }, [_vm._v("Preface")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This is the story of a group of young people who landed up in a derelict trouser factory in a rundown part of Leeds in Yorkshire and, between them, produced programming to conquer the television world.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They attracted – or, indeed, created – stars of international fame: Catherine Zeta Jones, James Mason, Alan Whicker, David Jason, David Frost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They produced programmes which changed our society.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the Dales and Wolds of Yorkshire earned new renown as ‘Heartbeat Country’ or just the ‘real Emmerdale’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the process, the young producers and crews found themselves in all sorts of dramatic and absurd situations. This book has vivid personal accounts of crises and comedy, both in front of and behind the camera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Yorkshire Television crews seemed always to contain someone who delighted in capturing with their own camera the private moments that amused them – and many of the most intriguing pictures in this book come from the sound recordists, make-up artists or production secretaries who worked on the shows.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Together, these things paint a fascinating picture of the making, from nothing, of one of the great television studios of its time.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-481ed943","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Chapter_1.vue
// module id = 69
// module chunks = 0